

export enum SynchronizationState {
    SYNCHRONIZED, NOT_SYNCHRONIZED_NOT_SENDED, NOT_SYNCHRONIZED_SENDED, FAIL
}
